// Attributes that tell browser password managers "this is not a credential
// field — leave it alone." Search boxes, task titles, todo entries etc. get
// misread as username fields (Dashlane especially), which pops its login/
// autofill prompt over the page. Spread this onto any such plain text input:
//
//   <input {...IGNORE_PW_MANAGERS} ... />
//
// data-form-type="other" is the signal Dashlane honours; the rest cover
// LastPass / 1Password / Bitwarden.
export const IGNORE_PW_MANAGERS = {
  autoComplete: 'off',
  'data-form-type': 'other',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
};
